import { default as academyHIclVNeOhuMeta } from "/home/forge/pininfarina.it/releases/20250626133331/pages/about/academy.vue?macro=true";
import { default as awardsYkTK0pSlcYMeta } from "/home/forge/pininfarina.it/releases/20250626133331/pages/about/awards.vue?macro=true";
import { default as certificationsSD5akncPnJMeta } from "/home/forge/pininfarina.it/releases/20250626133331/pages/about/certifications.vue?macro=true";
import { default as heritageQfGudWIhC4Meta } from "/home/forge/pininfarina.it/releases/20250626133331/pages/about/heritage.vue?macro=true";
import { default as indexB4V7J6kf02Meta } from "/home/forge/pininfarina.it/releases/20250626133331/pages/about/index.vue?macro=true";
import { default as our_45group6YqOXaGHgpMeta } from "/home/forge/pininfarina.it/releases/20250626133331/pages/about/our-group.vue?macro=true";
import { default as partnersE6XZWfJe9pMeta } from "/home/forge/pininfarina.it/releases/20250626133331/pages/about/partners.vue?macro=true";
import { default as sustainabilityuLn9yTJJUQMeta } from "/home/forge/pininfarina.it/releases/20250626133331/pages/about/sustainability.vue?macro=true";
import { default as teamNFdLg6OihVMeta } from "/home/forge/pininfarina.it/releases/20250626133331/pages/about/team.vue?macro=true";
import { default as visit_45pininfarinavdUu6SYtDfMeta } from "/home/forge/pininfarina.it/releases/20250626133331/pages/about/visit-pininfarina.vue?macro=true";
import { default as indexaP6HgkFwMXMeta } from "/home/forge/pininfarina.it/releases/20250626133331/pages/approach/index.vue?macro=true";
import { default as methodologyUU2FP5V03nMeta } from "/home/forge/pininfarina.it/releases/20250626133331/pages/approach/methodology.vue?macro=true";
import { default as _91jobSlug_93E6YqBp8N9qMeta } from "/home/forge/pininfarina.it/releases/20250626133331/pages/careers/[jobSlug].vue?macro=true";
import { default as indexEg80hglcqaMeta } from "/home/forge/pininfarina.it/releases/20250626133331/pages/careers/index.vue?macro=true";
import { default as indexm3KGCGckH7Meta } from "/home/forge/pininfarina.it/releases/20250626133331/pages/classiche/index.vue?macro=true";
import { default as _91countrySlug_93leyikhQB0KMeta } from "/home/forge/pininfarina.it/releases/20250626133331/pages/contacts/[countrySlug].vue?macro=true";
import { default as index1zC704KTAPMeta } from "/home/forge/pininfarina.it/releases/20250626133331/pages/contacts/index.vue?macro=true";
import { default as messageSentEUWeIjtA5VMeta } from "/home/forge/pininfarina.it/releases/20250626133331/pages/contacts/messageSent.vue?macro=true";
import { default as our_45offices2iHeRNUgqtMeta } from "/home/forge/pininfarina.it/releases/20250626133331/pages/contacts/our-offices.vue?macro=true";
import { default as cookie_45policypcxjCq5hmlMeta } from "/home/forge/pininfarina.it/releases/20250626133331/pages/cookie-policy.vue?macro=true";
import { default as index1I6JkuwaxmMeta } from "/home/forge/pininfarina.it/releases/20250626133331/pages/index.vue?macro=true";
import { default as indexxVOJ8VS1TkMeta } from "/home/forge/pininfarina.it/releases/20250626133331/pages/investor-relations/[[investorSlug]]/index.vue?macro=true";
import { default as hq_45resourcesUfIEgZol1zMeta } from "/home/forge/pininfarina.it/releases/20250626133331/pages/media-hub/hq-resources.vue?macro=true";
import { default as indexOnDN9ZWGuEMeta } from "/home/forge/pininfarina.it/releases/20250626133331/pages/media-hub/index.vue?macro=true";
import { default as loginQ5joEhYXlYMeta } from "/home/forge/pininfarina.it/releases/20250626133331/pages/media-hub/login.vue?macro=true";
import { default as _91newsSlug_93dRfLTmodTEMeta } from "/home/forge/pininfarina.it/releases/20250626133331/pages/news/[newsSlug].vue?macro=true";
import { default as indexPwlbW0TZwSMeta } from "/home/forge/pininfarina.it/releases/20250626133331/pages/news/index.vue?macro=true";
import { default as successuYZc5IWlm1Meta } from "/home/forge/pininfarina.it/releases/20250626133331/pages/pardot/success.vue?macro=true";
import { default as privacy_45policyZkyGJH0RqwMeta } from "/home/forge/pininfarina.it/releases/20250626133331/pages/privacy-policy.vue?macro=true";
import { default as _91projectSlug_930zduFJe8aAMeta } from "/home/forge/pininfarina.it/releases/20250626133331/pages/projects/[projectSlug].vue?macro=true";
import { default as index8BFkkiwNsJMeta } from "/home/forge/pininfarina.it/releases/20250626133331/pages/projects/index.vue?macro=true";
import { default as indexd8oaj7GuBsMeta } from "/home/forge/pininfarina.it/releases/20250626133331/pages/search/index.vue?macro=true";
import { default as indexCWAdJ66pHwMeta } from "/home/forge/pininfarina.it/releases/20250626133331/pages/sectors/[sectorSlug]/index.vue?macro=true";
import { default as portfolioY4i5RMnZWlMeta } from "/home/forge/pininfarina.it/releases/20250626133331/pages/sectors/[sectorSlug]/portfolio.vue?macro=true";
import { default as indexdLDhKUGO14Meta } from "/home/forge/pininfarina.it/releases/20250626133331/pages/sectors/index.vue?macro=true";
import { default as _91serviceSlug_93SUMAFIG1z1Meta } from "/home/forge/pininfarina.it/releases/20250626133331/pages/services/[serviceSlug].vue?macro=true";
import { default as indexQWueirygOeMeta } from "/home/forge/pininfarina.it/releases/20250626133331/pages/services/index.vue?macro=true";
import { default as indexgV1aaVH35CMeta } from "/home/forge/pininfarina.it/releases/20250626133331/pages/whistleblowing/index.vue?macro=true";
import { default as pininfarinaQxqbsifz2OMeta } from "/home/forge/pininfarina.it/releases/20250626133331/node_modules/nuxt/dist/pages/runtime/component-stub?macro=true";
export default [
  {
    name: academyHIclVNeOhuMeta?.name ?? "about-academy___de",
    path: academyHIclVNeOhuMeta?.path ?? "/de/um/pininfarina-academy",
    meta: academyHIclVNeOhuMeta || {},
    alias: academyHIclVNeOhuMeta?.alias || [],
    redirect: academyHIclVNeOhuMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/about/academy.vue").then(m => m.default || m)
  },
  {
    name: academyHIclVNeOhuMeta?.name ?? "about-academy___en___default",
    path: academyHIclVNeOhuMeta?.path ?? "/about/pininfarina-academy",
    meta: academyHIclVNeOhuMeta || {},
    alias: academyHIclVNeOhuMeta?.alias || [],
    redirect: academyHIclVNeOhuMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/about/academy.vue").then(m => m.default || m)
  },
  {
    name: academyHIclVNeOhuMeta?.name ?? "about-academy___en",
    path: academyHIclVNeOhuMeta?.path ?? "/en/about/pininfarina-academy",
    meta: academyHIclVNeOhuMeta || {},
    alias: academyHIclVNeOhuMeta?.alias || [],
    redirect: academyHIclVNeOhuMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/about/academy.vue").then(m => m.default || m)
  },
  {
    name: academyHIclVNeOhuMeta?.name ?? "about-academy___it",
    path: academyHIclVNeOhuMeta?.path ?? "/it/about/pininfarina-academy",
    meta: academyHIclVNeOhuMeta || {},
    alias: academyHIclVNeOhuMeta?.alias || [],
    redirect: academyHIclVNeOhuMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/about/academy.vue").then(m => m.default || m)
  },
  {
    name: academyHIclVNeOhuMeta?.name ?? "about-academy___zh",
    path: academyHIclVNeOhuMeta?.path ?? "/zh/guanyu/pininfarina-academy",
    meta: academyHIclVNeOhuMeta || {},
    alias: academyHIclVNeOhuMeta?.alias || [],
    redirect: academyHIclVNeOhuMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/about/academy.vue").then(m => m.default || m)
  },
  {
    name: awardsYkTK0pSlcYMeta?.name ?? "about-awards___de",
    path: awardsYkTK0pSlcYMeta?.path ?? "/de/um/auszeichnungen",
    meta: awardsYkTK0pSlcYMeta || {},
    alias: awardsYkTK0pSlcYMeta?.alias || [],
    redirect: awardsYkTK0pSlcYMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/about/awards.vue").then(m => m.default || m)
  },
  {
    name: awardsYkTK0pSlcYMeta?.name ?? "about-awards___en___default",
    path: awardsYkTK0pSlcYMeta?.path ?? "/about/awards",
    meta: awardsYkTK0pSlcYMeta || {},
    alias: awardsYkTK0pSlcYMeta?.alias || [],
    redirect: awardsYkTK0pSlcYMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/about/awards.vue").then(m => m.default || m)
  },
  {
    name: awardsYkTK0pSlcYMeta?.name ?? "about-awards___en",
    path: awardsYkTK0pSlcYMeta?.path ?? "/en/about/awards",
    meta: awardsYkTK0pSlcYMeta || {},
    alias: awardsYkTK0pSlcYMeta?.alias || [],
    redirect: awardsYkTK0pSlcYMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/about/awards.vue").then(m => m.default || m)
  },
  {
    name: awardsYkTK0pSlcYMeta?.name ?? "about-awards___it",
    path: awardsYkTK0pSlcYMeta?.path ?? "/it/about/premi",
    meta: awardsYkTK0pSlcYMeta || {},
    alias: awardsYkTK0pSlcYMeta?.alias || [],
    redirect: awardsYkTK0pSlcYMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/about/awards.vue").then(m => m.default || m)
  },
  {
    name: awardsYkTK0pSlcYMeta?.name ?? "about-awards___zh",
    path: awardsYkTK0pSlcYMeta?.path ?? "/zh/guanyu/jiangxiang",
    meta: awardsYkTK0pSlcYMeta || {},
    alias: awardsYkTK0pSlcYMeta?.alias || [],
    redirect: awardsYkTK0pSlcYMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/about/awards.vue").then(m => m.default || m)
  },
  {
    name: certificationsSD5akncPnJMeta?.name ?? "about-certifications___de",
    path: certificationsSD5akncPnJMeta?.path ?? "/de/about/certifications",
    meta: certificationsSD5akncPnJMeta || {},
    alias: certificationsSD5akncPnJMeta?.alias || [],
    redirect: certificationsSD5akncPnJMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/about/certifications.vue").then(m => m.default || m)
  },
  {
    name: certificationsSD5akncPnJMeta?.name ?? "about-certifications___en___default",
    path: certificationsSD5akncPnJMeta?.path ?? "/about/certifications",
    meta: certificationsSD5akncPnJMeta || {},
    alias: certificationsSD5akncPnJMeta?.alias || [],
    redirect: certificationsSD5akncPnJMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/about/certifications.vue").then(m => m.default || m)
  },
  {
    name: certificationsSD5akncPnJMeta?.name ?? "about-certifications___en",
    path: certificationsSD5akncPnJMeta?.path ?? "/en/about/certifications",
    meta: certificationsSD5akncPnJMeta || {},
    alias: certificationsSD5akncPnJMeta?.alias || [],
    redirect: certificationsSD5akncPnJMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/about/certifications.vue").then(m => m.default || m)
  },
  {
    name: certificationsSD5akncPnJMeta?.name ?? "about-certifications___it",
    path: certificationsSD5akncPnJMeta?.path ?? "/it/about/certifications",
    meta: certificationsSD5akncPnJMeta || {},
    alias: certificationsSD5akncPnJMeta?.alias || [],
    redirect: certificationsSD5akncPnJMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/about/certifications.vue").then(m => m.default || m)
  },
  {
    name: certificationsSD5akncPnJMeta?.name ?? "about-certifications___zh",
    path: certificationsSD5akncPnJMeta?.path ?? "/zh/about/certifications",
    meta: certificationsSD5akncPnJMeta || {},
    alias: certificationsSD5akncPnJMeta?.alias || [],
    redirect: certificationsSD5akncPnJMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/about/certifications.vue").then(m => m.default || m)
  },
  {
    name: heritageQfGudWIhC4Meta?.name ?? "about-heritage___de",
    path: heritageQfGudWIhC4Meta?.path ?? "/de/um/erbe",
    meta: heritageQfGudWIhC4Meta || {},
    alias: heritageQfGudWIhC4Meta?.alias || [],
    redirect: heritageQfGudWIhC4Meta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/about/heritage.vue").then(m => m.default || m)
  },
  {
    name: heritageQfGudWIhC4Meta?.name ?? "about-heritage___en___default",
    path: heritageQfGudWIhC4Meta?.path ?? "/about/heritage",
    meta: heritageQfGudWIhC4Meta || {},
    alias: heritageQfGudWIhC4Meta?.alias || [],
    redirect: heritageQfGudWIhC4Meta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/about/heritage.vue").then(m => m.default || m)
  },
  {
    name: heritageQfGudWIhC4Meta?.name ?? "about-heritage___en",
    path: heritageQfGudWIhC4Meta?.path ?? "/en/about/heritage",
    meta: heritageQfGudWIhC4Meta || {},
    alias: heritageQfGudWIhC4Meta?.alias || [],
    redirect: heritageQfGudWIhC4Meta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/about/heritage.vue").then(m => m.default || m)
  },
  {
    name: heritageQfGudWIhC4Meta?.name ?? "about-heritage___it",
    path: heritageQfGudWIhC4Meta?.path ?? "/it/about/heritage",
    meta: heritageQfGudWIhC4Meta || {},
    alias: heritageQfGudWIhC4Meta?.alias || [],
    redirect: heritageQfGudWIhC4Meta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/about/heritage.vue").then(m => m.default || m)
  },
  {
    name: heritageQfGudWIhC4Meta?.name ?? "about-heritage___zh",
    path: heritageQfGudWIhC4Meta?.path ?? "/zh/guanyu/yichan",
    meta: heritageQfGudWIhC4Meta || {},
    alias: heritageQfGudWIhC4Meta?.alias || [],
    redirect: heritageQfGudWIhC4Meta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/about/heritage.vue").then(m => m.default || m)
  },
  {
    name: indexB4V7J6kf02Meta?.name ?? "about___de",
    path: indexB4V7J6kf02Meta?.path ?? "/de/um",
    meta: indexB4V7J6kf02Meta || {},
    alias: indexB4V7J6kf02Meta?.alias || [],
    redirect: indexB4V7J6kf02Meta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/about/index.vue").then(m => m.default || m)
  },
  {
    name: indexB4V7J6kf02Meta?.name ?? "about___en___default",
    path: indexB4V7J6kf02Meta?.path ?? "/about/",
    meta: indexB4V7J6kf02Meta || {},
    alias: indexB4V7J6kf02Meta?.alias || [],
    redirect: indexB4V7J6kf02Meta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/about/index.vue").then(m => m.default || m)
  },
  {
    name: indexB4V7J6kf02Meta?.name ?? "about___en",
    path: indexB4V7J6kf02Meta?.path ?? "/en/about",
    meta: indexB4V7J6kf02Meta || {},
    alias: indexB4V7J6kf02Meta?.alias || [],
    redirect: indexB4V7J6kf02Meta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/about/index.vue").then(m => m.default || m)
  },
  {
    name: indexB4V7J6kf02Meta?.name ?? "about___it",
    path: indexB4V7J6kf02Meta?.path ?? "/it/about",
    meta: indexB4V7J6kf02Meta || {},
    alias: indexB4V7J6kf02Meta?.alias || [],
    redirect: indexB4V7J6kf02Meta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/about/index.vue").then(m => m.default || m)
  },
  {
    name: indexB4V7J6kf02Meta?.name ?? "about___zh",
    path: indexB4V7J6kf02Meta?.path ?? "/zh/guanyu",
    meta: indexB4V7J6kf02Meta || {},
    alias: indexB4V7J6kf02Meta?.alias || [],
    redirect: indexB4V7J6kf02Meta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/about/index.vue").then(m => m.default || m)
  },
  {
    name: our_45group6YqOXaGHgpMeta?.name ?? "about-our-group___de",
    path: our_45group6YqOXaGHgpMeta?.path ?? "/de/um/unsere-gruppe",
    meta: our_45group6YqOXaGHgpMeta || {},
    alias: our_45group6YqOXaGHgpMeta?.alias || [],
    redirect: our_45group6YqOXaGHgpMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/about/our-group.vue").then(m => m.default || m)
  },
  {
    name: our_45group6YqOXaGHgpMeta?.name ?? "about-our-group___en___default",
    path: our_45group6YqOXaGHgpMeta?.path ?? "/about/our-group",
    meta: our_45group6YqOXaGHgpMeta || {},
    alias: our_45group6YqOXaGHgpMeta?.alias || [],
    redirect: our_45group6YqOXaGHgpMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/about/our-group.vue").then(m => m.default || m)
  },
  {
    name: our_45group6YqOXaGHgpMeta?.name ?? "about-our-group___en",
    path: our_45group6YqOXaGHgpMeta?.path ?? "/en/about/our-group",
    meta: our_45group6YqOXaGHgpMeta || {},
    alias: our_45group6YqOXaGHgpMeta?.alias || [],
    redirect: our_45group6YqOXaGHgpMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/about/our-group.vue").then(m => m.default || m)
  },
  {
    name: our_45group6YqOXaGHgpMeta?.name ?? "about-our-group___it",
    path: our_45group6YqOXaGHgpMeta?.path ?? "/it/about/il-gruppo",
    meta: our_45group6YqOXaGHgpMeta || {},
    alias: our_45group6YqOXaGHgpMeta?.alias || [],
    redirect: our_45group6YqOXaGHgpMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/about/our-group.vue").then(m => m.default || m)
  },
  {
    name: our_45group6YqOXaGHgpMeta?.name ?? "about-our-group___zh",
    path: our_45group6YqOXaGHgpMeta?.path ?? "/zh/guanyu/women-de-zu",
    meta: our_45group6YqOXaGHgpMeta || {},
    alias: our_45group6YqOXaGHgpMeta?.alias || [],
    redirect: our_45group6YqOXaGHgpMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/about/our-group.vue").then(m => m.default || m)
  },
  {
    name: partnersE6XZWfJe9pMeta?.name ?? "about-partners___de",
    path: partnersE6XZWfJe9pMeta?.path ?? "/de/about/partners",
    meta: partnersE6XZWfJe9pMeta || {},
    alias: partnersE6XZWfJe9pMeta?.alias || [],
    redirect: partnersE6XZWfJe9pMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/about/partners.vue").then(m => m.default || m)
  },
  {
    name: partnersE6XZWfJe9pMeta?.name ?? "about-partners___en___default",
    path: partnersE6XZWfJe9pMeta?.path ?? "/about/partners",
    meta: partnersE6XZWfJe9pMeta || {},
    alias: partnersE6XZWfJe9pMeta?.alias || [],
    redirect: partnersE6XZWfJe9pMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/about/partners.vue").then(m => m.default || m)
  },
  {
    name: partnersE6XZWfJe9pMeta?.name ?? "about-partners___en",
    path: partnersE6XZWfJe9pMeta?.path ?? "/en/about/partners",
    meta: partnersE6XZWfJe9pMeta || {},
    alias: partnersE6XZWfJe9pMeta?.alias || [],
    redirect: partnersE6XZWfJe9pMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/about/partners.vue").then(m => m.default || m)
  },
  {
    name: partnersE6XZWfJe9pMeta?.name ?? "about-partners___it",
    path: partnersE6XZWfJe9pMeta?.path ?? "/it/about/partners",
    meta: partnersE6XZWfJe9pMeta || {},
    alias: partnersE6XZWfJe9pMeta?.alias || [],
    redirect: partnersE6XZWfJe9pMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/about/partners.vue").then(m => m.default || m)
  },
  {
    name: partnersE6XZWfJe9pMeta?.name ?? "about-partners___zh",
    path: partnersE6XZWfJe9pMeta?.path ?? "/zh/about/partners",
    meta: partnersE6XZWfJe9pMeta || {},
    alias: partnersE6XZWfJe9pMeta?.alias || [],
    redirect: partnersE6XZWfJe9pMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/about/partners.vue").then(m => m.default || m)
  },
  {
    name: sustainabilityuLn9yTJJUQMeta?.name ?? "about-sustainability___de",
    path: sustainabilityuLn9yTJJUQMeta?.path ?? "/de/um/nachhaltigkeit",
    meta: sustainabilityuLn9yTJJUQMeta || {},
    alias: sustainabilityuLn9yTJJUQMeta?.alias || [],
    redirect: sustainabilityuLn9yTJJUQMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/about/sustainability.vue").then(m => m.default || m)
  },
  {
    name: sustainabilityuLn9yTJJUQMeta?.name ?? "about-sustainability___en___default",
    path: sustainabilityuLn9yTJJUQMeta?.path ?? "/about/sustainability",
    meta: sustainabilityuLn9yTJJUQMeta || {},
    alias: sustainabilityuLn9yTJJUQMeta?.alias || [],
    redirect: sustainabilityuLn9yTJJUQMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/about/sustainability.vue").then(m => m.default || m)
  },
  {
    name: sustainabilityuLn9yTJJUQMeta?.name ?? "about-sustainability___en",
    path: sustainabilityuLn9yTJJUQMeta?.path ?? "/en/about/sustainability",
    meta: sustainabilityuLn9yTJJUQMeta || {},
    alias: sustainabilityuLn9yTJJUQMeta?.alias || [],
    redirect: sustainabilityuLn9yTJJUQMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/about/sustainability.vue").then(m => m.default || m)
  },
  {
    name: sustainabilityuLn9yTJJUQMeta?.name ?? "about-sustainability___it",
    path: sustainabilityuLn9yTJJUQMeta?.path ?? "/it/about/sostenibilita",
    meta: sustainabilityuLn9yTJJUQMeta || {},
    alias: sustainabilityuLn9yTJJUQMeta?.alias || [],
    redirect: sustainabilityuLn9yTJJUQMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/about/sustainability.vue").then(m => m.default || m)
  },
  {
    name: sustainabilityuLn9yTJJUQMeta?.name ?? "about-sustainability___zh",
    path: sustainabilityuLn9yTJJUQMeta?.path ?? "/zh/guanyu/ke-chixu-xing",
    meta: sustainabilityuLn9yTJJUQMeta || {},
    alias: sustainabilityuLn9yTJJUQMeta?.alias || [],
    redirect: sustainabilityuLn9yTJJUQMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/about/sustainability.vue").then(m => m.default || m)
  },
  {
    name: teamNFdLg6OihVMeta?.name ?? "about-team___de",
    path: teamNFdLg6OihVMeta?.path ?? "/de/um/team",
    meta: teamNFdLg6OihVMeta || {},
    alias: teamNFdLg6OihVMeta?.alias || [],
    redirect: teamNFdLg6OihVMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/about/team.vue").then(m => m.default || m)
  },
  {
    name: teamNFdLg6OihVMeta?.name ?? "about-team___en___default",
    path: teamNFdLg6OihVMeta?.path ?? "/about/team",
    meta: teamNFdLg6OihVMeta || {},
    alias: teamNFdLg6OihVMeta?.alias || [],
    redirect: teamNFdLg6OihVMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/about/team.vue").then(m => m.default || m)
  },
  {
    name: teamNFdLg6OihVMeta?.name ?? "about-team___en",
    path: teamNFdLg6OihVMeta?.path ?? "/en/about/team",
    meta: teamNFdLg6OihVMeta || {},
    alias: teamNFdLg6OihVMeta?.alias || [],
    redirect: teamNFdLg6OihVMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/about/team.vue").then(m => m.default || m)
  },
  {
    name: teamNFdLg6OihVMeta?.name ?? "about-team___it",
    path: teamNFdLg6OihVMeta?.path ?? "/it/about/team",
    meta: teamNFdLg6OihVMeta || {},
    alias: teamNFdLg6OihVMeta?.alias || [],
    redirect: teamNFdLg6OihVMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/about/team.vue").then(m => m.default || m)
  },
  {
    name: teamNFdLg6OihVMeta?.name ?? "about-team___zh",
    path: teamNFdLg6OihVMeta?.path ?? "/zh/guanyu/tuandui",
    meta: teamNFdLg6OihVMeta || {},
    alias: teamNFdLg6OihVMeta?.alias || [],
    redirect: teamNFdLg6OihVMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/about/team.vue").then(m => m.default || m)
  },
  {
    name: visit_45pininfarinavdUu6SYtDfMeta?.name ?? "about-visit-pininfarina___de",
    path: visit_45pininfarinavdUu6SYtDfMeta?.path ?? "/de/um/besuchen-sie-pininfarina",
    meta: visit_45pininfarinavdUu6SYtDfMeta || {},
    alias: visit_45pininfarinavdUu6SYtDfMeta?.alias || [],
    redirect: visit_45pininfarinavdUu6SYtDfMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/about/visit-pininfarina.vue").then(m => m.default || m)
  },
  {
    name: visit_45pininfarinavdUu6SYtDfMeta?.name ?? "about-visit-pininfarina___en___default",
    path: visit_45pininfarinavdUu6SYtDfMeta?.path ?? "/about/visit-pininfarina",
    meta: visit_45pininfarinavdUu6SYtDfMeta || {},
    alias: visit_45pininfarinavdUu6SYtDfMeta?.alias || [],
    redirect: visit_45pininfarinavdUu6SYtDfMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/about/visit-pininfarina.vue").then(m => m.default || m)
  },
  {
    name: visit_45pininfarinavdUu6SYtDfMeta?.name ?? "about-visit-pininfarina___en",
    path: visit_45pininfarinavdUu6SYtDfMeta?.path ?? "/en/about/visit-pininfarina",
    meta: visit_45pininfarinavdUu6SYtDfMeta || {},
    alias: visit_45pininfarinavdUu6SYtDfMeta?.alias || [],
    redirect: visit_45pininfarinavdUu6SYtDfMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/about/visit-pininfarina.vue").then(m => m.default || m)
  },
  {
    name: visit_45pininfarinavdUu6SYtDfMeta?.name ?? "about-visit-pininfarina___it",
    path: visit_45pininfarinavdUu6SYtDfMeta?.path ?? "/it/about/visita-pininfarina",
    meta: visit_45pininfarinavdUu6SYtDfMeta || {},
    alias: visit_45pininfarinavdUu6SYtDfMeta?.alias || [],
    redirect: visit_45pininfarinavdUu6SYtDfMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/about/visit-pininfarina.vue").then(m => m.default || m)
  },
  {
    name: visit_45pininfarinavdUu6SYtDfMeta?.name ?? "about-visit-pininfarina___zh",
    path: visit_45pininfarinavdUu6SYtDfMeta?.path ?? "/zh/guanyu/hui-pininfarina",
    meta: visit_45pininfarinavdUu6SYtDfMeta || {},
    alias: visit_45pininfarinavdUu6SYtDfMeta?.alias || [],
    redirect: visit_45pininfarinavdUu6SYtDfMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/about/visit-pininfarina.vue").then(m => m.default || m)
  },
  {
    name: indexaP6HgkFwMXMeta?.name ?? "approach___de",
    path: indexaP6HgkFwMXMeta?.path ?? "/de/approach",
    meta: indexaP6HgkFwMXMeta || {},
    alias: indexaP6HgkFwMXMeta?.alias || [],
    redirect: indexaP6HgkFwMXMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/approach/index.vue").then(m => m.default || m)
  },
  {
    name: indexaP6HgkFwMXMeta?.name ?? "approach___en___default",
    path: indexaP6HgkFwMXMeta?.path ?? "/approach",
    meta: indexaP6HgkFwMXMeta || {},
    alias: indexaP6HgkFwMXMeta?.alias || [],
    redirect: indexaP6HgkFwMXMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/approach/index.vue").then(m => m.default || m)
  },
  {
    name: indexaP6HgkFwMXMeta?.name ?? "approach___en",
    path: indexaP6HgkFwMXMeta?.path ?? "/en/approach",
    meta: indexaP6HgkFwMXMeta || {},
    alias: indexaP6HgkFwMXMeta?.alias || [],
    redirect: indexaP6HgkFwMXMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/approach/index.vue").then(m => m.default || m)
  },
  {
    name: indexaP6HgkFwMXMeta?.name ?? "approach___it",
    path: indexaP6HgkFwMXMeta?.path ?? "/it/approach",
    meta: indexaP6HgkFwMXMeta || {},
    alias: indexaP6HgkFwMXMeta?.alias || [],
    redirect: indexaP6HgkFwMXMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/approach/index.vue").then(m => m.default || m)
  },
  {
    name: indexaP6HgkFwMXMeta?.name ?? "approach___zh",
    path: indexaP6HgkFwMXMeta?.path ?? "/zh/approach",
    meta: indexaP6HgkFwMXMeta || {},
    alias: indexaP6HgkFwMXMeta?.alias || [],
    redirect: indexaP6HgkFwMXMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/approach/index.vue").then(m => m.default || m)
  },
  {
    name: methodologyUU2FP5V03nMeta?.name ?? "approach-methodology___de",
    path: methodologyUU2FP5V03nMeta?.path ?? "/de/approach/methodology",
    meta: methodologyUU2FP5V03nMeta || {},
    alias: methodologyUU2FP5V03nMeta?.alias || [],
    redirect: methodologyUU2FP5V03nMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/approach/methodology.vue").then(m => m.default || m)
  },
  {
    name: methodologyUU2FP5V03nMeta?.name ?? "approach-methodology___en___default",
    path: methodologyUU2FP5V03nMeta?.path ?? "/approach/methodology",
    meta: methodologyUU2FP5V03nMeta || {},
    alias: methodologyUU2FP5V03nMeta?.alias || [],
    redirect: methodologyUU2FP5V03nMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/approach/methodology.vue").then(m => m.default || m)
  },
  {
    name: methodologyUU2FP5V03nMeta?.name ?? "approach-methodology___en",
    path: methodologyUU2FP5V03nMeta?.path ?? "/en/approach/methodology",
    meta: methodologyUU2FP5V03nMeta || {},
    alias: methodologyUU2FP5V03nMeta?.alias || [],
    redirect: methodologyUU2FP5V03nMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/approach/methodology.vue").then(m => m.default || m)
  },
  {
    name: methodologyUU2FP5V03nMeta?.name ?? "approach-methodology___it",
    path: methodologyUU2FP5V03nMeta?.path ?? "/it/approach/methodology",
    meta: methodologyUU2FP5V03nMeta || {},
    alias: methodologyUU2FP5V03nMeta?.alias || [],
    redirect: methodologyUU2FP5V03nMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/approach/methodology.vue").then(m => m.default || m)
  },
  {
    name: methodologyUU2FP5V03nMeta?.name ?? "approach-methodology___zh",
    path: methodologyUU2FP5V03nMeta?.path ?? "/zh/approach/methodology",
    meta: methodologyUU2FP5V03nMeta || {},
    alias: methodologyUU2FP5V03nMeta?.alias || [],
    redirect: methodologyUU2FP5V03nMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/approach/methodology.vue").then(m => m.default || m)
  },
  {
    name: _91jobSlug_93E6YqBp8N9qMeta?.name ?? "careers-jobSlug___de",
    path: _91jobSlug_93E6YqBp8N9qMeta?.path ?? "/de/karriere/:jobSlug",
    meta: _91jobSlug_93E6YqBp8N9qMeta || {},
    alias: _91jobSlug_93E6YqBp8N9qMeta?.alias || [],
    redirect: _91jobSlug_93E6YqBp8N9qMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/careers/[jobSlug].vue").then(m => m.default || m)
  },
  {
    name: _91jobSlug_93E6YqBp8N9qMeta?.name ?? "careers-jobSlug___en___default",
    path: _91jobSlug_93E6YqBp8N9qMeta?.path ?? "/careers/:jobSlug",
    meta: _91jobSlug_93E6YqBp8N9qMeta || {},
    alias: _91jobSlug_93E6YqBp8N9qMeta?.alias || [],
    redirect: _91jobSlug_93E6YqBp8N9qMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/careers/[jobSlug].vue").then(m => m.default || m)
  },
  {
    name: _91jobSlug_93E6YqBp8N9qMeta?.name ?? "careers-jobSlug___en",
    path: _91jobSlug_93E6YqBp8N9qMeta?.path ?? "/en/careers/:jobSlug",
    meta: _91jobSlug_93E6YqBp8N9qMeta || {},
    alias: _91jobSlug_93E6YqBp8N9qMeta?.alias || [],
    redirect: _91jobSlug_93E6YqBp8N9qMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/careers/[jobSlug].vue").then(m => m.default || m)
  },
  {
    name: _91jobSlug_93E6YqBp8N9qMeta?.name ?? "careers-jobSlug___it",
    path: _91jobSlug_93E6YqBp8N9qMeta?.path ?? "/it/carriere/:jobSlug",
    meta: _91jobSlug_93E6YqBp8N9qMeta || {},
    alias: _91jobSlug_93E6YqBp8N9qMeta?.alias || [],
    redirect: _91jobSlug_93E6YqBp8N9qMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/careers/[jobSlug].vue").then(m => m.default || m)
  },
  {
    name: _91jobSlug_93E6YqBp8N9qMeta?.name ?? "careers-jobSlug___zh",
    path: _91jobSlug_93E6YqBp8N9qMeta?.path ?? "/zh/zhiye-shengya/:jobSlug",
    meta: _91jobSlug_93E6YqBp8N9qMeta || {},
    alias: _91jobSlug_93E6YqBp8N9qMeta?.alias || [],
    redirect: _91jobSlug_93E6YqBp8N9qMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/careers/[jobSlug].vue").then(m => m.default || m)
  },
  {
    name: indexEg80hglcqaMeta?.name ?? "careers___de",
    path: indexEg80hglcqaMeta?.path ?? "/de/karriere",
    meta: indexEg80hglcqaMeta || {},
    alias: indexEg80hglcqaMeta?.alias || [],
    redirect: indexEg80hglcqaMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/careers/index.vue").then(m => m.default || m)
  },
  {
    name: indexEg80hglcqaMeta?.name ?? "careers___en___default",
    path: indexEg80hglcqaMeta?.path ?? "/careers/",
    meta: indexEg80hglcqaMeta || {},
    alias: indexEg80hglcqaMeta?.alias || [],
    redirect: indexEg80hglcqaMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/careers/index.vue").then(m => m.default || m)
  },
  {
    name: indexEg80hglcqaMeta?.name ?? "careers___en",
    path: indexEg80hglcqaMeta?.path ?? "/en/careers",
    meta: indexEg80hglcqaMeta || {},
    alias: indexEg80hglcqaMeta?.alias || [],
    redirect: indexEg80hglcqaMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/careers/index.vue").then(m => m.default || m)
  },
  {
    name: indexEg80hglcqaMeta?.name ?? "careers___it",
    path: indexEg80hglcqaMeta?.path ?? "/it/carriere",
    meta: indexEg80hglcqaMeta || {},
    alias: indexEg80hglcqaMeta?.alias || [],
    redirect: indexEg80hglcqaMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/careers/index.vue").then(m => m.default || m)
  },
  {
    name: indexEg80hglcqaMeta?.name ?? "careers___zh",
    path: indexEg80hglcqaMeta?.path ?? "/zh/zhiye-shengya",
    meta: indexEg80hglcqaMeta || {},
    alias: indexEg80hglcqaMeta?.alias || [],
    redirect: indexEg80hglcqaMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/careers/index.vue").then(m => m.default || m)
  },
  {
    name: indexm3KGCGckH7Meta?.name ?? "classiche___de",
    path: indexm3KGCGckH7Meta?.path ?? "/de/classiche",
    meta: indexm3KGCGckH7Meta || {},
    alias: indexm3KGCGckH7Meta?.alias || [],
    redirect: indexm3KGCGckH7Meta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/classiche/index.vue").then(m => m.default || m)
  },
  {
    name: indexm3KGCGckH7Meta?.name ?? "classiche___en___default",
    path: indexm3KGCGckH7Meta?.path ?? "/classiche/",
    meta: indexm3KGCGckH7Meta || {},
    alias: indexm3KGCGckH7Meta?.alias || [],
    redirect: indexm3KGCGckH7Meta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/classiche/index.vue").then(m => m.default || m)
  },
  {
    name: indexm3KGCGckH7Meta?.name ?? "classiche___en",
    path: indexm3KGCGckH7Meta?.path ?? "/en/classiche",
    meta: indexm3KGCGckH7Meta || {},
    alias: indexm3KGCGckH7Meta?.alias || [],
    redirect: indexm3KGCGckH7Meta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/classiche/index.vue").then(m => m.default || m)
  },
  {
    name: indexm3KGCGckH7Meta?.name ?? "classiche___it",
    path: indexm3KGCGckH7Meta?.path ?? "/it/classiche",
    meta: indexm3KGCGckH7Meta || {},
    alias: indexm3KGCGckH7Meta?.alias || [],
    redirect: indexm3KGCGckH7Meta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/classiche/index.vue").then(m => m.default || m)
  },
  {
    name: indexm3KGCGckH7Meta?.name ?? "classiche___zh",
    path: indexm3KGCGckH7Meta?.path ?? "/zh/classiche",
    meta: indexm3KGCGckH7Meta || {},
    alias: indexm3KGCGckH7Meta?.alias || [],
    redirect: indexm3KGCGckH7Meta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/classiche/index.vue").then(m => m.default || m)
  },
  {
    name: _91countrySlug_93leyikhQB0KMeta?.name ?? "contacts-countrySlug___de",
    path: _91countrySlug_93leyikhQB0KMeta?.path ?? "/de/kontakte/:countrySlug",
    meta: _91countrySlug_93leyikhQB0KMeta || {},
    alias: _91countrySlug_93leyikhQB0KMeta?.alias || [],
    redirect: _91countrySlug_93leyikhQB0KMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/contacts/[countrySlug].vue").then(m => m.default || m)
  },
  {
    name: _91countrySlug_93leyikhQB0KMeta?.name ?? "contacts-countrySlug___en___default",
    path: _91countrySlug_93leyikhQB0KMeta?.path ?? "/contacts/:countrySlug",
    meta: _91countrySlug_93leyikhQB0KMeta || {},
    alias: _91countrySlug_93leyikhQB0KMeta?.alias || [],
    redirect: _91countrySlug_93leyikhQB0KMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/contacts/[countrySlug].vue").then(m => m.default || m)
  },
  {
    name: _91countrySlug_93leyikhQB0KMeta?.name ?? "contacts-countrySlug___en",
    path: _91countrySlug_93leyikhQB0KMeta?.path ?? "/en/contacts/:countrySlug",
    meta: _91countrySlug_93leyikhQB0KMeta || {},
    alias: _91countrySlug_93leyikhQB0KMeta?.alias || [],
    redirect: _91countrySlug_93leyikhQB0KMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/contacts/[countrySlug].vue").then(m => m.default || m)
  },
  {
    name: _91countrySlug_93leyikhQB0KMeta?.name ?? "contacts-countrySlug___it",
    path: _91countrySlug_93leyikhQB0KMeta?.path ?? "/it/contatti/:countrySlug",
    meta: _91countrySlug_93leyikhQB0KMeta || {},
    alias: _91countrySlug_93leyikhQB0KMeta?.alias || [],
    redirect: _91countrySlug_93leyikhQB0KMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/contacts/[countrySlug].vue").then(m => m.default || m)
  },
  {
    name: _91countrySlug_93leyikhQB0KMeta?.name ?? "contacts-countrySlug___zh",
    path: _91countrySlug_93leyikhQB0KMeta?.path ?? "/zh/lianxi-ren/:countrySlug",
    meta: _91countrySlug_93leyikhQB0KMeta || {},
    alias: _91countrySlug_93leyikhQB0KMeta?.alias || [],
    redirect: _91countrySlug_93leyikhQB0KMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/contacts/[countrySlug].vue").then(m => m.default || m)
  },
  {
    name: index1zC704KTAPMeta?.name ?? "contacts___de",
    path: index1zC704KTAPMeta?.path ?? "/de/kontakte",
    meta: index1zC704KTAPMeta || {},
    alias: index1zC704KTAPMeta?.alias || [],
    redirect: index1zC704KTAPMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/contacts/index.vue").then(m => m.default || m)
  },
  {
    name: index1zC704KTAPMeta?.name ?? "contacts___en___default",
    path: index1zC704KTAPMeta?.path ?? "/contacts/",
    meta: index1zC704KTAPMeta || {},
    alias: index1zC704KTAPMeta?.alias || [],
    redirect: index1zC704KTAPMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/contacts/index.vue").then(m => m.default || m)
  },
  {
    name: index1zC704KTAPMeta?.name ?? "contacts___en",
    path: index1zC704KTAPMeta?.path ?? "/en/contacts",
    meta: index1zC704KTAPMeta || {},
    alias: index1zC704KTAPMeta?.alias || [],
    redirect: index1zC704KTAPMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/contacts/index.vue").then(m => m.default || m)
  },
  {
    name: index1zC704KTAPMeta?.name ?? "contacts___it",
    path: index1zC704KTAPMeta?.path ?? "/it/contatti",
    meta: index1zC704KTAPMeta || {},
    alias: index1zC704KTAPMeta?.alias || [],
    redirect: index1zC704KTAPMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/contacts/index.vue").then(m => m.default || m)
  },
  {
    name: index1zC704KTAPMeta?.name ?? "contacts___zh",
    path: index1zC704KTAPMeta?.path ?? "/zh/lianxi-ren",
    meta: index1zC704KTAPMeta || {},
    alias: index1zC704KTAPMeta?.alias || [],
    redirect: index1zC704KTAPMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/contacts/index.vue").then(m => m.default || m)
  },
  {
    name: messageSentEUWeIjtA5VMeta?.name ?? "contacts-messageSent___de",
    path: messageSentEUWeIjtA5VMeta?.path ?? "/de/message-sent",
    meta: messageSentEUWeIjtA5VMeta || {},
    alias: messageSentEUWeIjtA5VMeta?.alias || [],
    redirect: messageSentEUWeIjtA5VMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/contacts/messageSent.vue").then(m => m.default || m)
  },
  {
    name: messageSentEUWeIjtA5VMeta?.name ?? "contacts-messageSent___en___default",
    path: messageSentEUWeIjtA5VMeta?.path ?? "/message-sent",
    meta: messageSentEUWeIjtA5VMeta || {},
    alias: messageSentEUWeIjtA5VMeta?.alias || [],
    redirect: messageSentEUWeIjtA5VMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/contacts/messageSent.vue").then(m => m.default || m)
  },
  {
    name: messageSentEUWeIjtA5VMeta?.name ?? "contacts-messageSent___en",
    path: messageSentEUWeIjtA5VMeta?.path ?? "/en/message-sent",
    meta: messageSentEUWeIjtA5VMeta || {},
    alias: messageSentEUWeIjtA5VMeta?.alias || [],
    redirect: messageSentEUWeIjtA5VMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/contacts/messageSent.vue").then(m => m.default || m)
  },
  {
    name: messageSentEUWeIjtA5VMeta?.name ?? "contacts-messageSent___it",
    path: messageSentEUWeIjtA5VMeta?.path ?? "/it/message-sent",
    meta: messageSentEUWeIjtA5VMeta || {},
    alias: messageSentEUWeIjtA5VMeta?.alias || [],
    redirect: messageSentEUWeIjtA5VMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/contacts/messageSent.vue").then(m => m.default || m)
  },
  {
    name: messageSentEUWeIjtA5VMeta?.name ?? "contacts-messageSent___zh",
    path: messageSentEUWeIjtA5VMeta?.path ?? "/zh/message-sent",
    meta: messageSentEUWeIjtA5VMeta || {},
    alias: messageSentEUWeIjtA5VMeta?.alias || [],
    redirect: messageSentEUWeIjtA5VMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/contacts/messageSent.vue").then(m => m.default || m)
  },
  {
    name: our_45offices2iHeRNUgqtMeta?.name ?? "contacts-our-offices___de",
    path: our_45offices2iHeRNUgqtMeta?.path ?? "/de/kontakte/unsere-gruppe",
    meta: our_45offices2iHeRNUgqtMeta || {},
    alias: our_45offices2iHeRNUgqtMeta?.alias || [],
    redirect: our_45offices2iHeRNUgqtMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/contacts/our-offices.vue").then(m => m.default || m)
  },
  {
    name: our_45offices2iHeRNUgqtMeta?.name ?? "contacts-our-offices___en___default",
    path: our_45offices2iHeRNUgqtMeta?.path ?? "/contacts/our-offices",
    meta: our_45offices2iHeRNUgqtMeta || {},
    alias: our_45offices2iHeRNUgqtMeta?.alias || [],
    redirect: our_45offices2iHeRNUgqtMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/contacts/our-offices.vue").then(m => m.default || m)
  },
  {
    name: our_45offices2iHeRNUgqtMeta?.name ?? "contacts-our-offices___en",
    path: our_45offices2iHeRNUgqtMeta?.path ?? "/en/contacts/our-offices",
    meta: our_45offices2iHeRNUgqtMeta || {},
    alias: our_45offices2iHeRNUgqtMeta?.alias || [],
    redirect: our_45offices2iHeRNUgqtMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/contacts/our-offices.vue").then(m => m.default || m)
  },
  {
    name: our_45offices2iHeRNUgqtMeta?.name ?? "contacts-our-offices___it",
    path: our_45offices2iHeRNUgqtMeta?.path ?? "/it/contatti/i-nostri-uffici",
    meta: our_45offices2iHeRNUgqtMeta || {},
    alias: our_45offices2iHeRNUgqtMeta?.alias || [],
    redirect: our_45offices2iHeRNUgqtMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/contacts/our-offices.vue").then(m => m.default || m)
  },
  {
    name: our_45offices2iHeRNUgqtMeta?.name ?? "contacts-our-offices___zh",
    path: our_45offices2iHeRNUgqtMeta?.path ?? "/zh/lianxi-ren/women-de-zu",
    meta: our_45offices2iHeRNUgqtMeta || {},
    alias: our_45offices2iHeRNUgqtMeta?.alias || [],
    redirect: our_45offices2iHeRNUgqtMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/contacts/our-offices.vue").then(m => m.default || m)
  },
  {
    name: cookie_45policypcxjCq5hmlMeta?.name ?? "cookie-policy___de",
    path: cookie_45policypcxjCq5hmlMeta?.path ?? "/de/cookie-policy",
    meta: cookie_45policypcxjCq5hmlMeta || {},
    alias: cookie_45policypcxjCq5hmlMeta?.alias || [],
    redirect: cookie_45policypcxjCq5hmlMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/cookie-policy.vue").then(m => m.default || m)
  },
  {
    name: cookie_45policypcxjCq5hmlMeta?.name ?? "cookie-policy___en___default",
    path: cookie_45policypcxjCq5hmlMeta?.path ?? "/cookie-policy/",
    meta: cookie_45policypcxjCq5hmlMeta || {},
    alias: cookie_45policypcxjCq5hmlMeta?.alias || [],
    redirect: cookie_45policypcxjCq5hmlMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/cookie-policy.vue").then(m => m.default || m)
  },
  {
    name: cookie_45policypcxjCq5hmlMeta?.name ?? "cookie-policy___en",
    path: cookie_45policypcxjCq5hmlMeta?.path ?? "/en/cookie-policy",
    meta: cookie_45policypcxjCq5hmlMeta || {},
    alias: cookie_45policypcxjCq5hmlMeta?.alias || [],
    redirect: cookie_45policypcxjCq5hmlMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/cookie-policy.vue").then(m => m.default || m)
  },
  {
    name: cookie_45policypcxjCq5hmlMeta?.name ?? "cookie-policy___it",
    path: cookie_45policypcxjCq5hmlMeta?.path ?? "/it/cookie-policy",
    meta: cookie_45policypcxjCq5hmlMeta || {},
    alias: cookie_45policypcxjCq5hmlMeta?.alias || [],
    redirect: cookie_45policypcxjCq5hmlMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/cookie-policy.vue").then(m => m.default || m)
  },
  {
    name: cookie_45policypcxjCq5hmlMeta?.name ?? "cookie-policy___zh",
    path: cookie_45policypcxjCq5hmlMeta?.path ?? "/zh/cookie-policy",
    meta: cookie_45policypcxjCq5hmlMeta || {},
    alias: cookie_45policypcxjCq5hmlMeta?.alias || [],
    redirect: cookie_45policypcxjCq5hmlMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/cookie-policy.vue").then(m => m.default || m)
  },
  {
    name: index1I6JkuwaxmMeta?.name ?? "index___de",
    path: index1I6JkuwaxmMeta?.path ?? "/de",
    meta: index1I6JkuwaxmMeta || {},
    alias: index1I6JkuwaxmMeta?.alias || [],
    redirect: index1I6JkuwaxmMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/index.vue").then(m => m.default || m)
  },
  {
    name: index1I6JkuwaxmMeta?.name ?? "index___en___default",
    path: index1I6JkuwaxmMeta?.path ?? "/",
    meta: index1I6JkuwaxmMeta || {},
    alias: index1I6JkuwaxmMeta?.alias || [],
    redirect: index1I6JkuwaxmMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/index.vue").then(m => m.default || m)
  },
  {
    name: index1I6JkuwaxmMeta?.name ?? "index___en",
    path: index1I6JkuwaxmMeta?.path ?? "/en",
    meta: index1I6JkuwaxmMeta || {},
    alias: index1I6JkuwaxmMeta?.alias || [],
    redirect: index1I6JkuwaxmMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/index.vue").then(m => m.default || m)
  },
  {
    name: index1I6JkuwaxmMeta?.name ?? "index___it",
    path: index1I6JkuwaxmMeta?.path ?? "/it",
    meta: index1I6JkuwaxmMeta || {},
    alias: index1I6JkuwaxmMeta?.alias || [],
    redirect: index1I6JkuwaxmMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/index.vue").then(m => m.default || m)
  },
  {
    name: index1I6JkuwaxmMeta?.name ?? "index___zh",
    path: index1I6JkuwaxmMeta?.path ?? "/zh",
    meta: index1I6JkuwaxmMeta || {},
    alias: index1I6JkuwaxmMeta?.alias || [],
    redirect: index1I6JkuwaxmMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexxVOJ8VS1TkMeta?.name ?? "investor-relations-investorSlug___de",
    path: indexxVOJ8VS1TkMeta?.path ?? "/de/investor-relations/:investorSlug?",
    meta: indexxVOJ8VS1TkMeta || {},
    alias: indexxVOJ8VS1TkMeta?.alias || [],
    redirect: indexxVOJ8VS1TkMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/investor-relations/[[investorSlug]]/index.vue").then(m => m.default || m)
  },
  {
    name: indexxVOJ8VS1TkMeta?.name ?? "investor-relations-investorSlug___en___default",
    path: indexxVOJ8VS1TkMeta?.path ?? "/investor-relations/:investorSlug?",
    meta: indexxVOJ8VS1TkMeta || {},
    alias: indexxVOJ8VS1TkMeta?.alias || [],
    redirect: indexxVOJ8VS1TkMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/investor-relations/[[investorSlug]]/index.vue").then(m => m.default || m)
  },
  {
    name: indexxVOJ8VS1TkMeta?.name ?? "investor-relations-investorSlug___en",
    path: indexxVOJ8VS1TkMeta?.path ?? "/en/investor-relations/:investorSlug?",
    meta: indexxVOJ8VS1TkMeta || {},
    alias: indexxVOJ8VS1TkMeta?.alias || [],
    redirect: indexxVOJ8VS1TkMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/investor-relations/[[investorSlug]]/index.vue").then(m => m.default || m)
  },
  {
    name: indexxVOJ8VS1TkMeta?.name ?? "investor-relations-investorSlug___it",
    path: indexxVOJ8VS1TkMeta?.path ?? "/it/investor-relations/:investorSlug?",
    meta: indexxVOJ8VS1TkMeta || {},
    alias: indexxVOJ8VS1TkMeta?.alias || [],
    redirect: indexxVOJ8VS1TkMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/investor-relations/[[investorSlug]]/index.vue").then(m => m.default || m)
  },
  {
    name: indexxVOJ8VS1TkMeta?.name ?? "investor-relations-investorSlug___zh",
    path: indexxVOJ8VS1TkMeta?.path ?? "/zh/investor-relations/:investorSlug?",
    meta: indexxVOJ8VS1TkMeta || {},
    alias: indexxVOJ8VS1TkMeta?.alias || [],
    redirect: indexxVOJ8VS1TkMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/investor-relations/[[investorSlug]]/index.vue").then(m => m.default || m)
  },
  {
    name: hq_45resourcesUfIEgZol1zMeta?.name ?? "media-hub-hq-resources___de",
    path: hq_45resourcesUfIEgZol1zMeta?.path ?? "/de/media-hub/hq-resources",
    meta: hq_45resourcesUfIEgZol1zMeta || {},
    alias: hq_45resourcesUfIEgZol1zMeta?.alias || [],
    redirect: hq_45resourcesUfIEgZol1zMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/media-hub/hq-resources.vue").then(m => m.default || m)
  },
  {
    name: hq_45resourcesUfIEgZol1zMeta?.name ?? "media-hub-hq-resources___en___default",
    path: hq_45resourcesUfIEgZol1zMeta?.path ?? "/media-hub/hq-resources",
    meta: hq_45resourcesUfIEgZol1zMeta || {},
    alias: hq_45resourcesUfIEgZol1zMeta?.alias || [],
    redirect: hq_45resourcesUfIEgZol1zMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/media-hub/hq-resources.vue").then(m => m.default || m)
  },
  {
    name: hq_45resourcesUfIEgZol1zMeta?.name ?? "media-hub-hq-resources___en",
    path: hq_45resourcesUfIEgZol1zMeta?.path ?? "/en/media-hub/hq-resources",
    meta: hq_45resourcesUfIEgZol1zMeta || {},
    alias: hq_45resourcesUfIEgZol1zMeta?.alias || [],
    redirect: hq_45resourcesUfIEgZol1zMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/media-hub/hq-resources.vue").then(m => m.default || m)
  },
  {
    name: hq_45resourcesUfIEgZol1zMeta?.name ?? "media-hub-hq-resources___it",
    path: hq_45resourcesUfIEgZol1zMeta?.path ?? "/it/media-hub/hq-resources",
    meta: hq_45resourcesUfIEgZol1zMeta || {},
    alias: hq_45resourcesUfIEgZol1zMeta?.alias || [],
    redirect: hq_45resourcesUfIEgZol1zMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/media-hub/hq-resources.vue").then(m => m.default || m)
  },
  {
    name: hq_45resourcesUfIEgZol1zMeta?.name ?? "media-hub-hq-resources___zh",
    path: hq_45resourcesUfIEgZol1zMeta?.path ?? "/zh/media-hub/hq-resources",
    meta: hq_45resourcesUfIEgZol1zMeta || {},
    alias: hq_45resourcesUfIEgZol1zMeta?.alias || [],
    redirect: hq_45resourcesUfIEgZol1zMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/media-hub/hq-resources.vue").then(m => m.default || m)
  },
  {
    name: indexOnDN9ZWGuEMeta?.name ?? "media-hub___de",
    path: indexOnDN9ZWGuEMeta?.path ?? "/de/media-hub",
    meta: indexOnDN9ZWGuEMeta || {},
    alias: indexOnDN9ZWGuEMeta?.alias || [],
    redirect: indexOnDN9ZWGuEMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/media-hub/index.vue").then(m => m.default || m)
  },
  {
    name: indexOnDN9ZWGuEMeta?.name ?? "media-hub___en___default",
    path: indexOnDN9ZWGuEMeta?.path ?? "/media-hub/",
    meta: indexOnDN9ZWGuEMeta || {},
    alias: indexOnDN9ZWGuEMeta?.alias || [],
    redirect: indexOnDN9ZWGuEMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/media-hub/index.vue").then(m => m.default || m)
  },
  {
    name: indexOnDN9ZWGuEMeta?.name ?? "media-hub___en",
    path: indexOnDN9ZWGuEMeta?.path ?? "/en/media-hub",
    meta: indexOnDN9ZWGuEMeta || {},
    alias: indexOnDN9ZWGuEMeta?.alias || [],
    redirect: indexOnDN9ZWGuEMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/media-hub/index.vue").then(m => m.default || m)
  },
  {
    name: indexOnDN9ZWGuEMeta?.name ?? "media-hub___it",
    path: indexOnDN9ZWGuEMeta?.path ?? "/it/media-hub",
    meta: indexOnDN9ZWGuEMeta || {},
    alias: indexOnDN9ZWGuEMeta?.alias || [],
    redirect: indexOnDN9ZWGuEMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/media-hub/index.vue").then(m => m.default || m)
  },
  {
    name: indexOnDN9ZWGuEMeta?.name ?? "media-hub___zh",
    path: indexOnDN9ZWGuEMeta?.path ?? "/zh/media-hub",
    meta: indexOnDN9ZWGuEMeta || {},
    alias: indexOnDN9ZWGuEMeta?.alias || [],
    redirect: indexOnDN9ZWGuEMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/media-hub/index.vue").then(m => m.default || m)
  },
  {
    name: loginQ5joEhYXlYMeta?.name ?? "media-hub-login___de",
    path: loginQ5joEhYXlYMeta?.path ?? "/de/media-hub/login",
    meta: loginQ5joEhYXlYMeta || {},
    alias: loginQ5joEhYXlYMeta?.alias || [],
    redirect: loginQ5joEhYXlYMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/media-hub/login.vue").then(m => m.default || m)
  },
  {
    name: loginQ5joEhYXlYMeta?.name ?? "media-hub-login___en___default",
    path: loginQ5joEhYXlYMeta?.path ?? "/media-hub/login",
    meta: loginQ5joEhYXlYMeta || {},
    alias: loginQ5joEhYXlYMeta?.alias || [],
    redirect: loginQ5joEhYXlYMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/media-hub/login.vue").then(m => m.default || m)
  },
  {
    name: loginQ5joEhYXlYMeta?.name ?? "media-hub-login___en",
    path: loginQ5joEhYXlYMeta?.path ?? "/en/media-hub/login",
    meta: loginQ5joEhYXlYMeta || {},
    alias: loginQ5joEhYXlYMeta?.alias || [],
    redirect: loginQ5joEhYXlYMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/media-hub/login.vue").then(m => m.default || m)
  },
  {
    name: loginQ5joEhYXlYMeta?.name ?? "media-hub-login___it",
    path: loginQ5joEhYXlYMeta?.path ?? "/it/media-hub/login",
    meta: loginQ5joEhYXlYMeta || {},
    alias: loginQ5joEhYXlYMeta?.alias || [],
    redirect: loginQ5joEhYXlYMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/media-hub/login.vue").then(m => m.default || m)
  },
  {
    name: loginQ5joEhYXlYMeta?.name ?? "media-hub-login___zh",
    path: loginQ5joEhYXlYMeta?.path ?? "/zh/media-hub/login",
    meta: loginQ5joEhYXlYMeta || {},
    alias: loginQ5joEhYXlYMeta?.alias || [],
    redirect: loginQ5joEhYXlYMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/media-hub/login.vue").then(m => m.default || m)
  },
  {
    name: _91newsSlug_93dRfLTmodTEMeta?.name ?? "news-newsSlug___de",
    path: _91newsSlug_93dRfLTmodTEMeta?.path ?? "/de/nachrichten/:newsSlug",
    meta: _91newsSlug_93dRfLTmodTEMeta || {},
    alias: _91newsSlug_93dRfLTmodTEMeta?.alias || [],
    redirect: _91newsSlug_93dRfLTmodTEMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/news/[newsSlug].vue").then(m => m.default || m)
  },
  {
    name: _91newsSlug_93dRfLTmodTEMeta?.name ?? "news-newsSlug___en___default",
    path: _91newsSlug_93dRfLTmodTEMeta?.path ?? "/news/:newsSlug",
    meta: _91newsSlug_93dRfLTmodTEMeta || {},
    alias: _91newsSlug_93dRfLTmodTEMeta?.alias || [],
    redirect: _91newsSlug_93dRfLTmodTEMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/news/[newsSlug].vue").then(m => m.default || m)
  },
  {
    name: _91newsSlug_93dRfLTmodTEMeta?.name ?? "news-newsSlug___en",
    path: _91newsSlug_93dRfLTmodTEMeta?.path ?? "/en/news/:newsSlug",
    meta: _91newsSlug_93dRfLTmodTEMeta || {},
    alias: _91newsSlug_93dRfLTmodTEMeta?.alias || [],
    redirect: _91newsSlug_93dRfLTmodTEMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/news/[newsSlug].vue").then(m => m.default || m)
  },
  {
    name: _91newsSlug_93dRfLTmodTEMeta?.name ?? "news-newsSlug___it",
    path: _91newsSlug_93dRfLTmodTEMeta?.path ?? "/it/notizie/:newsSlug",
    meta: _91newsSlug_93dRfLTmodTEMeta || {},
    alias: _91newsSlug_93dRfLTmodTEMeta?.alias || [],
    redirect: _91newsSlug_93dRfLTmodTEMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/news/[newsSlug].vue").then(m => m.default || m)
  },
  {
    name: _91newsSlug_93dRfLTmodTEMeta?.name ?? "news-newsSlug___zh",
    path: _91newsSlug_93dRfLTmodTEMeta?.path ?? "/zh/xinwen/:newsSlug",
    meta: _91newsSlug_93dRfLTmodTEMeta || {},
    alias: _91newsSlug_93dRfLTmodTEMeta?.alias || [],
    redirect: _91newsSlug_93dRfLTmodTEMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/news/[newsSlug].vue").then(m => m.default || m)
  },
  {
    name: indexPwlbW0TZwSMeta?.name ?? "news___de",
    path: indexPwlbW0TZwSMeta?.path ?? "/de/nachrichten",
    meta: indexPwlbW0TZwSMeta || {},
    alias: indexPwlbW0TZwSMeta?.alias || [],
    redirect: indexPwlbW0TZwSMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/news/index.vue").then(m => m.default || m)
  },
  {
    name: indexPwlbW0TZwSMeta?.name ?? "news___en___default",
    path: indexPwlbW0TZwSMeta?.path ?? "/news/",
    meta: indexPwlbW0TZwSMeta || {},
    alias: indexPwlbW0TZwSMeta?.alias || [],
    redirect: indexPwlbW0TZwSMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/news/index.vue").then(m => m.default || m)
  },
  {
    name: indexPwlbW0TZwSMeta?.name ?? "news___en",
    path: indexPwlbW0TZwSMeta?.path ?? "/en/news",
    meta: indexPwlbW0TZwSMeta || {},
    alias: indexPwlbW0TZwSMeta?.alias || [],
    redirect: indexPwlbW0TZwSMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/news/index.vue").then(m => m.default || m)
  },
  {
    name: indexPwlbW0TZwSMeta?.name ?? "news___it",
    path: indexPwlbW0TZwSMeta?.path ?? "/it/notizie",
    meta: indexPwlbW0TZwSMeta || {},
    alias: indexPwlbW0TZwSMeta?.alias || [],
    redirect: indexPwlbW0TZwSMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/news/index.vue").then(m => m.default || m)
  },
  {
    name: indexPwlbW0TZwSMeta?.name ?? "news___zh",
    path: indexPwlbW0TZwSMeta?.path ?? "/zh/xinwen",
    meta: indexPwlbW0TZwSMeta || {},
    alias: indexPwlbW0TZwSMeta?.alias || [],
    redirect: indexPwlbW0TZwSMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/news/index.vue").then(m => m.default || m)
  },
  {
    name: successuYZc5IWlm1Meta?.name ?? "pardot-success___de",
    path: successuYZc5IWlm1Meta?.path ?? "/de/pardot/success",
    meta: successuYZc5IWlm1Meta || {},
    alias: successuYZc5IWlm1Meta?.alias || [],
    redirect: successuYZc5IWlm1Meta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/pardot/success.vue").then(m => m.default || m)
  },
  {
    name: successuYZc5IWlm1Meta?.name ?? "pardot-success___en___default",
    path: successuYZc5IWlm1Meta?.path ?? "/pardot/success",
    meta: successuYZc5IWlm1Meta || {},
    alias: successuYZc5IWlm1Meta?.alias || [],
    redirect: successuYZc5IWlm1Meta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/pardot/success.vue").then(m => m.default || m)
  },
  {
    name: successuYZc5IWlm1Meta?.name ?? "pardot-success___en",
    path: successuYZc5IWlm1Meta?.path ?? "/en/pardot/success",
    meta: successuYZc5IWlm1Meta || {},
    alias: successuYZc5IWlm1Meta?.alias || [],
    redirect: successuYZc5IWlm1Meta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/pardot/success.vue").then(m => m.default || m)
  },
  {
    name: successuYZc5IWlm1Meta?.name ?? "pardot-success___it",
    path: successuYZc5IWlm1Meta?.path ?? "/it/pardot/success",
    meta: successuYZc5IWlm1Meta || {},
    alias: successuYZc5IWlm1Meta?.alias || [],
    redirect: successuYZc5IWlm1Meta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/pardot/success.vue").then(m => m.default || m)
  },
  {
    name: successuYZc5IWlm1Meta?.name ?? "pardot-success___zh",
    path: successuYZc5IWlm1Meta?.path ?? "/zh/pardot/success",
    meta: successuYZc5IWlm1Meta || {},
    alias: successuYZc5IWlm1Meta?.alias || [],
    redirect: successuYZc5IWlm1Meta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/pardot/success.vue").then(m => m.default || m)
  },
  {
    name: privacy_45policyZkyGJH0RqwMeta?.name ?? "privacy-policy___de",
    path: privacy_45policyZkyGJH0RqwMeta?.path ?? "/de/privacy-policy",
    meta: privacy_45policyZkyGJH0RqwMeta || {},
    alias: privacy_45policyZkyGJH0RqwMeta?.alias || [],
    redirect: privacy_45policyZkyGJH0RqwMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: privacy_45policyZkyGJH0RqwMeta?.name ?? "privacy-policy___en___default",
    path: privacy_45policyZkyGJH0RqwMeta?.path ?? "/privacy-policy/",
    meta: privacy_45policyZkyGJH0RqwMeta || {},
    alias: privacy_45policyZkyGJH0RqwMeta?.alias || [],
    redirect: privacy_45policyZkyGJH0RqwMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: privacy_45policyZkyGJH0RqwMeta?.name ?? "privacy-policy___en",
    path: privacy_45policyZkyGJH0RqwMeta?.path ?? "/en/privacy-policy",
    meta: privacy_45policyZkyGJH0RqwMeta || {},
    alias: privacy_45policyZkyGJH0RqwMeta?.alias || [],
    redirect: privacy_45policyZkyGJH0RqwMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: privacy_45policyZkyGJH0RqwMeta?.name ?? "privacy-policy___it",
    path: privacy_45policyZkyGJH0RqwMeta?.path ?? "/it/privacy-policy",
    meta: privacy_45policyZkyGJH0RqwMeta || {},
    alias: privacy_45policyZkyGJH0RqwMeta?.alias || [],
    redirect: privacy_45policyZkyGJH0RqwMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: privacy_45policyZkyGJH0RqwMeta?.name ?? "privacy-policy___zh",
    path: privacy_45policyZkyGJH0RqwMeta?.path ?? "/zh/privacy-policy",
    meta: privacy_45policyZkyGJH0RqwMeta || {},
    alias: privacy_45policyZkyGJH0RqwMeta?.alias || [],
    redirect: privacy_45policyZkyGJH0RqwMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: _91projectSlug_930zduFJe8aAMeta?.name ?? "projects-projectSlug___de",
    path: _91projectSlug_930zduFJe8aAMeta?.path ?? "/de/projekte/:projectSlug",
    meta: _91projectSlug_930zduFJe8aAMeta || {},
    alias: _91projectSlug_930zduFJe8aAMeta?.alias || [],
    redirect: _91projectSlug_930zduFJe8aAMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/projects/[projectSlug].vue").then(m => m.default || m)
  },
  {
    name: _91projectSlug_930zduFJe8aAMeta?.name ?? "projects-projectSlug___en___default",
    path: _91projectSlug_930zduFJe8aAMeta?.path ?? "/projects/:projectSlug",
    meta: _91projectSlug_930zduFJe8aAMeta || {},
    alias: _91projectSlug_930zduFJe8aAMeta?.alias || [],
    redirect: _91projectSlug_930zduFJe8aAMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/projects/[projectSlug].vue").then(m => m.default || m)
  },
  {
    name: _91projectSlug_930zduFJe8aAMeta?.name ?? "projects-projectSlug___en",
    path: _91projectSlug_930zduFJe8aAMeta?.path ?? "/en/projects/:projectSlug",
    meta: _91projectSlug_930zduFJe8aAMeta || {},
    alias: _91projectSlug_930zduFJe8aAMeta?.alias || [],
    redirect: _91projectSlug_930zduFJe8aAMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/projects/[projectSlug].vue").then(m => m.default || m)
  },
  {
    name: _91projectSlug_930zduFJe8aAMeta?.name ?? "projects-projectSlug___it",
    path: _91projectSlug_930zduFJe8aAMeta?.path ?? "/it/progetti/:projectSlug",
    meta: _91projectSlug_930zduFJe8aAMeta || {},
    alias: _91projectSlug_930zduFJe8aAMeta?.alias || [],
    redirect: _91projectSlug_930zduFJe8aAMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/projects/[projectSlug].vue").then(m => m.default || m)
  },
  {
    name: _91projectSlug_930zduFJe8aAMeta?.name ?? "projects-projectSlug___zh",
    path: _91projectSlug_930zduFJe8aAMeta?.path ?? "/zh/xiangmu/:projectSlug",
    meta: _91projectSlug_930zduFJe8aAMeta || {},
    alias: _91projectSlug_930zduFJe8aAMeta?.alias || [],
    redirect: _91projectSlug_930zduFJe8aAMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/projects/[projectSlug].vue").then(m => m.default || m)
  },
  {
    name: index8BFkkiwNsJMeta?.name ?? "projects___de",
    path: index8BFkkiwNsJMeta?.path ?? "/de/projekte",
    meta: index8BFkkiwNsJMeta || {},
    alias: index8BFkkiwNsJMeta?.alias || [],
    redirect: index8BFkkiwNsJMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/projects/index.vue").then(m => m.default || m)
  },
  {
    name: index8BFkkiwNsJMeta?.name ?? "projects___en___default",
    path: index8BFkkiwNsJMeta?.path ?? "/projects/",
    meta: index8BFkkiwNsJMeta || {},
    alias: index8BFkkiwNsJMeta?.alias || [],
    redirect: index8BFkkiwNsJMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/projects/index.vue").then(m => m.default || m)
  },
  {
    name: index8BFkkiwNsJMeta?.name ?? "projects___en",
    path: index8BFkkiwNsJMeta?.path ?? "/en/projects",
    meta: index8BFkkiwNsJMeta || {},
    alias: index8BFkkiwNsJMeta?.alias || [],
    redirect: index8BFkkiwNsJMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/projects/index.vue").then(m => m.default || m)
  },
  {
    name: index8BFkkiwNsJMeta?.name ?? "projects___it",
    path: index8BFkkiwNsJMeta?.path ?? "/it/progetti",
    meta: index8BFkkiwNsJMeta || {},
    alias: index8BFkkiwNsJMeta?.alias || [],
    redirect: index8BFkkiwNsJMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/projects/index.vue").then(m => m.default || m)
  },
  {
    name: index8BFkkiwNsJMeta?.name ?? "projects___zh",
    path: index8BFkkiwNsJMeta?.path ?? "/zh/xiangmu",
    meta: index8BFkkiwNsJMeta || {},
    alias: index8BFkkiwNsJMeta?.alias || [],
    redirect: index8BFkkiwNsJMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/projects/index.vue").then(m => m.default || m)
  },
  {
    name: indexd8oaj7GuBsMeta?.name ?? "search___de",
    path: indexd8oaj7GuBsMeta?.path ?? "/de/suchen",
    meta: indexd8oaj7GuBsMeta || {},
    alias: indexd8oaj7GuBsMeta?.alias || [],
    redirect: indexd8oaj7GuBsMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/search/index.vue").then(m => m.default || m)
  },
  {
    name: indexd8oaj7GuBsMeta?.name ?? "search___en___default",
    path: indexd8oaj7GuBsMeta?.path ?? "/search/",
    meta: indexd8oaj7GuBsMeta || {},
    alias: indexd8oaj7GuBsMeta?.alias || [],
    redirect: indexd8oaj7GuBsMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/search/index.vue").then(m => m.default || m)
  },
  {
    name: indexd8oaj7GuBsMeta?.name ?? "search___en",
    path: indexd8oaj7GuBsMeta?.path ?? "/en/search",
    meta: indexd8oaj7GuBsMeta || {},
    alias: indexd8oaj7GuBsMeta?.alias || [],
    redirect: indexd8oaj7GuBsMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/search/index.vue").then(m => m.default || m)
  },
  {
    name: indexd8oaj7GuBsMeta?.name ?? "search___it",
    path: indexd8oaj7GuBsMeta?.path ?? "/it/ricerca",
    meta: indexd8oaj7GuBsMeta || {},
    alias: indexd8oaj7GuBsMeta?.alias || [],
    redirect: indexd8oaj7GuBsMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/search/index.vue").then(m => m.default || m)
  },
  {
    name: indexd8oaj7GuBsMeta?.name ?? "search___zh",
    path: indexd8oaj7GuBsMeta?.path ?? "/zh/sousuo",
    meta: indexd8oaj7GuBsMeta || {},
    alias: indexd8oaj7GuBsMeta?.alias || [],
    redirect: indexd8oaj7GuBsMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/search/index.vue").then(m => m.default || m)
  },
  {
    name: indexCWAdJ66pHwMeta?.name ?? "sectors-sectorSlug___de",
    path: indexCWAdJ66pHwMeta?.path ?? "/de/sektoren/:sectorSlug",
    meta: indexCWAdJ66pHwMeta || {},
    alias: indexCWAdJ66pHwMeta?.alias || [],
    redirect: indexCWAdJ66pHwMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/sectors/[sectorSlug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexCWAdJ66pHwMeta?.name ?? "sectors-sectorSlug___en___default",
    path: indexCWAdJ66pHwMeta?.path ?? "/sectors/:sectorSlug/",
    meta: indexCWAdJ66pHwMeta || {},
    alias: indexCWAdJ66pHwMeta?.alias || [],
    redirect: indexCWAdJ66pHwMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/sectors/[sectorSlug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexCWAdJ66pHwMeta?.name ?? "sectors-sectorSlug___en",
    path: indexCWAdJ66pHwMeta?.path ?? "/en/sectors/:sectorSlug",
    meta: indexCWAdJ66pHwMeta || {},
    alias: indexCWAdJ66pHwMeta?.alias || [],
    redirect: indexCWAdJ66pHwMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/sectors/[sectorSlug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexCWAdJ66pHwMeta?.name ?? "sectors-sectorSlug___it",
    path: indexCWAdJ66pHwMeta?.path ?? "/it/settori/:sectorSlug",
    meta: indexCWAdJ66pHwMeta || {},
    alias: indexCWAdJ66pHwMeta?.alias || [],
    redirect: indexCWAdJ66pHwMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/sectors/[sectorSlug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexCWAdJ66pHwMeta?.name ?? "sectors-sectorSlug___zh",
    path: indexCWAdJ66pHwMeta?.path ?? "/zh/bumen/:sectorSlug",
    meta: indexCWAdJ66pHwMeta || {},
    alias: indexCWAdJ66pHwMeta?.alias || [],
    redirect: indexCWAdJ66pHwMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/sectors/[sectorSlug]/index.vue").then(m => m.default || m)
  },
  {
    name: portfolioY4i5RMnZWlMeta?.name ?? "sectors-sectorSlug-portfolio___de",
    path: portfolioY4i5RMnZWlMeta?.path ?? "/de/sektoren/:sectorSlug/portfolio",
    meta: portfolioY4i5RMnZWlMeta || {},
    alias: portfolioY4i5RMnZWlMeta?.alias || [],
    redirect: portfolioY4i5RMnZWlMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/sectors/[sectorSlug]/portfolio.vue").then(m => m.default || m)
  },
  {
    name: portfolioY4i5RMnZWlMeta?.name ?? "sectors-sectorSlug-portfolio___en___default",
    path: portfolioY4i5RMnZWlMeta?.path ?? "/sectors/:sectorSlug/portfolio",
    meta: portfolioY4i5RMnZWlMeta || {},
    alias: portfolioY4i5RMnZWlMeta?.alias || [],
    redirect: portfolioY4i5RMnZWlMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/sectors/[sectorSlug]/portfolio.vue").then(m => m.default || m)
  },
  {
    name: portfolioY4i5RMnZWlMeta?.name ?? "sectors-sectorSlug-portfolio___en",
    path: portfolioY4i5RMnZWlMeta?.path ?? "/en/sectors/:sectorSlug/portfolio",
    meta: portfolioY4i5RMnZWlMeta || {},
    alias: portfolioY4i5RMnZWlMeta?.alias || [],
    redirect: portfolioY4i5RMnZWlMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/sectors/[sectorSlug]/portfolio.vue").then(m => m.default || m)
  },
  {
    name: portfolioY4i5RMnZWlMeta?.name ?? "sectors-sectorSlug-portfolio___it",
    path: portfolioY4i5RMnZWlMeta?.path ?? "/it/settori/:sectorSlug/portfolio",
    meta: portfolioY4i5RMnZWlMeta || {},
    alias: portfolioY4i5RMnZWlMeta?.alias || [],
    redirect: portfolioY4i5RMnZWlMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/sectors/[sectorSlug]/portfolio.vue").then(m => m.default || m)
  },
  {
    name: portfolioY4i5RMnZWlMeta?.name ?? "sectors-sectorSlug-portfolio___zh",
    path: portfolioY4i5RMnZWlMeta?.path ?? "/zh/bumen/:sectorSlug/wenjian-jia",
    meta: portfolioY4i5RMnZWlMeta || {},
    alias: portfolioY4i5RMnZWlMeta?.alias || [],
    redirect: portfolioY4i5RMnZWlMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/sectors/[sectorSlug]/portfolio.vue").then(m => m.default || m)
  },
  {
    name: indexdLDhKUGO14Meta?.name ?? "sectors___de",
    path: indexdLDhKUGO14Meta?.path ?? "/de/sektoren",
    meta: indexdLDhKUGO14Meta || {},
    alias: indexdLDhKUGO14Meta?.alias || [],
    redirect: indexdLDhKUGO14Meta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/sectors/index.vue").then(m => m.default || m)
  },
  {
    name: indexdLDhKUGO14Meta?.name ?? "sectors___en___default",
    path: indexdLDhKUGO14Meta?.path ?? "/sectors/",
    meta: indexdLDhKUGO14Meta || {},
    alias: indexdLDhKUGO14Meta?.alias || [],
    redirect: indexdLDhKUGO14Meta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/sectors/index.vue").then(m => m.default || m)
  },
  {
    name: indexdLDhKUGO14Meta?.name ?? "sectors___en",
    path: indexdLDhKUGO14Meta?.path ?? "/en/sectors",
    meta: indexdLDhKUGO14Meta || {},
    alias: indexdLDhKUGO14Meta?.alias || [],
    redirect: indexdLDhKUGO14Meta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/sectors/index.vue").then(m => m.default || m)
  },
  {
    name: indexdLDhKUGO14Meta?.name ?? "sectors___it",
    path: indexdLDhKUGO14Meta?.path ?? "/it/settori",
    meta: indexdLDhKUGO14Meta || {},
    alias: indexdLDhKUGO14Meta?.alias || [],
    redirect: indexdLDhKUGO14Meta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/sectors/index.vue").then(m => m.default || m)
  },
  {
    name: indexdLDhKUGO14Meta?.name ?? "sectors___zh",
    path: indexdLDhKUGO14Meta?.path ?? "/zh/bumen",
    meta: indexdLDhKUGO14Meta || {},
    alias: indexdLDhKUGO14Meta?.alias || [],
    redirect: indexdLDhKUGO14Meta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/sectors/index.vue").then(m => m.default || m)
  },
  {
    name: _91serviceSlug_93SUMAFIG1z1Meta?.name ?? "services-serviceSlug___de",
    path: _91serviceSlug_93SUMAFIG1z1Meta?.path ?? "/de/dienstleistungen/:serviceSlug",
    meta: _91serviceSlug_93SUMAFIG1z1Meta || {},
    alias: _91serviceSlug_93SUMAFIG1z1Meta?.alias || [],
    redirect: _91serviceSlug_93SUMAFIG1z1Meta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/services/[serviceSlug].vue").then(m => m.default || m)
  },
  {
    name: _91serviceSlug_93SUMAFIG1z1Meta?.name ?? "services-serviceSlug___en___default",
    path: _91serviceSlug_93SUMAFIG1z1Meta?.path ?? "/services/:serviceSlug",
    meta: _91serviceSlug_93SUMAFIG1z1Meta || {},
    alias: _91serviceSlug_93SUMAFIG1z1Meta?.alias || [],
    redirect: _91serviceSlug_93SUMAFIG1z1Meta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/services/[serviceSlug].vue").then(m => m.default || m)
  },
  {
    name: _91serviceSlug_93SUMAFIG1z1Meta?.name ?? "services-serviceSlug___en",
    path: _91serviceSlug_93SUMAFIG1z1Meta?.path ?? "/en/services/:serviceSlug",
    meta: _91serviceSlug_93SUMAFIG1z1Meta || {},
    alias: _91serviceSlug_93SUMAFIG1z1Meta?.alias || [],
    redirect: _91serviceSlug_93SUMAFIG1z1Meta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/services/[serviceSlug].vue").then(m => m.default || m)
  },
  {
    name: _91serviceSlug_93SUMAFIG1z1Meta?.name ?? "services-serviceSlug___it",
    path: _91serviceSlug_93SUMAFIG1z1Meta?.path ?? "/it/servizi/:serviceSlug",
    meta: _91serviceSlug_93SUMAFIG1z1Meta || {},
    alias: _91serviceSlug_93SUMAFIG1z1Meta?.alias || [],
    redirect: _91serviceSlug_93SUMAFIG1z1Meta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/services/[serviceSlug].vue").then(m => m.default || m)
  },
  {
    name: _91serviceSlug_93SUMAFIG1z1Meta?.name ?? "services-serviceSlug___zh",
    path: _91serviceSlug_93SUMAFIG1z1Meta?.path ?? "/zh/fuwu/:serviceSlug",
    meta: _91serviceSlug_93SUMAFIG1z1Meta || {},
    alias: _91serviceSlug_93SUMAFIG1z1Meta?.alias || [],
    redirect: _91serviceSlug_93SUMAFIG1z1Meta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/services/[serviceSlug].vue").then(m => m.default || m)
  },
  {
    name: indexQWueirygOeMeta?.name ?? "services___de",
    path: indexQWueirygOeMeta?.path ?? "/de/dienstleistungen",
    meta: indexQWueirygOeMeta || {},
    alias: indexQWueirygOeMeta?.alias || [],
    redirect: indexQWueirygOeMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/services/index.vue").then(m => m.default || m)
  },
  {
    name: indexQWueirygOeMeta?.name ?? "services___en___default",
    path: indexQWueirygOeMeta?.path ?? "/services/",
    meta: indexQWueirygOeMeta || {},
    alias: indexQWueirygOeMeta?.alias || [],
    redirect: indexQWueirygOeMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/services/index.vue").then(m => m.default || m)
  },
  {
    name: indexQWueirygOeMeta?.name ?? "services___en",
    path: indexQWueirygOeMeta?.path ?? "/en/services",
    meta: indexQWueirygOeMeta || {},
    alias: indexQWueirygOeMeta?.alias || [],
    redirect: indexQWueirygOeMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/services/index.vue").then(m => m.default || m)
  },
  {
    name: indexQWueirygOeMeta?.name ?? "services___it",
    path: indexQWueirygOeMeta?.path ?? "/it/servizi",
    meta: indexQWueirygOeMeta || {},
    alias: indexQWueirygOeMeta?.alias || [],
    redirect: indexQWueirygOeMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/services/index.vue").then(m => m.default || m)
  },
  {
    name: indexQWueirygOeMeta?.name ?? "services___zh",
    path: indexQWueirygOeMeta?.path ?? "/zh/fuwu",
    meta: indexQWueirygOeMeta || {},
    alias: indexQWueirygOeMeta?.alias || [],
    redirect: indexQWueirygOeMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/services/index.vue").then(m => m.default || m)
  },
  {
    name: indexgV1aaVH35CMeta?.name ?? "whistleblowing___de",
    path: indexgV1aaVH35CMeta?.path ?? "/de/whistleblowing",
    meta: indexgV1aaVH35CMeta || {},
    alias: indexgV1aaVH35CMeta?.alias || [],
    redirect: indexgV1aaVH35CMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/whistleblowing/index.vue").then(m => m.default || m)
  },
  {
    name: indexgV1aaVH35CMeta?.name ?? "whistleblowing___en___default",
    path: indexgV1aaVH35CMeta?.path ?? "/whistleblowing/",
    meta: indexgV1aaVH35CMeta || {},
    alias: indexgV1aaVH35CMeta?.alias || [],
    redirect: indexgV1aaVH35CMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/whistleblowing/index.vue").then(m => m.default || m)
  },
  {
    name: indexgV1aaVH35CMeta?.name ?? "whistleblowing___en",
    path: indexgV1aaVH35CMeta?.path ?? "/en/whistleblowing",
    meta: indexgV1aaVH35CMeta || {},
    alias: indexgV1aaVH35CMeta?.alias || [],
    redirect: indexgV1aaVH35CMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/whistleblowing/index.vue").then(m => m.default || m)
  },
  {
    name: indexgV1aaVH35CMeta?.name ?? "whistleblowing___it",
    path: indexgV1aaVH35CMeta?.path ?? "/it/whistleblowing",
    meta: indexgV1aaVH35CMeta || {},
    alias: indexgV1aaVH35CMeta?.alias || [],
    redirect: indexgV1aaVH35CMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/whistleblowing/index.vue").then(m => m.default || m)
  },
  {
    name: indexgV1aaVH35CMeta?.name ?? "whistleblowing___zh",
    path: indexgV1aaVH35CMeta?.path ?? "/zh/whistleblowing",
    meta: indexgV1aaVH35CMeta || {},
    alias: indexgV1aaVH35CMeta?.alias || [],
    redirect: indexgV1aaVH35CMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/pages/whistleblowing/index.vue").then(m => m.default || m)
  },
  {
    name: pininfarinaQxqbsifz2OMeta?.name ?? undefined,
    path: pininfarinaQxqbsifz2OMeta?.path ?? "/sitemap.xml",
    meta: pininfarinaQxqbsifz2OMeta || {},
    alias: pininfarinaQxqbsifz2OMeta?.alias || [],
    redirect: pininfarinaQxqbsifz2OMeta?.redirect,
    component: () => import("/home/forge/pininfarina.it/releases/20250626133331/node_modules/nuxt/dist/pages/runtime/component-stub").then(m => m.default || m)
  }
]